//
//
//
//
//
//

import Badge from "@Shared/components/general/badge.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SubmissionStatusBadge",
  components: {
    Badge
  },
  props: {
    status: {
      type: String,
      default: ""
    }
  },
  computed: {
    badgeType() {
      const submissionStatusMap = {
        accepted: "success",
        approved: "success",
        confirmed: "success",
        "ready-to-close": "success",
        paid: "success",
        closed: "success",
        declined: "dark",
        cancelled: "dark",
        failed: "danger",
        processing: "light"
      };
      return submissionStatusMap[this.status] || "dark";
    }
  }
});